// AuthBackground.jsx
import React from 'react';

const AuthBackground = () => {
    return (
        <div
            className="relative border-gray-300 border-r-2 p-4 bg-cover bg-center h-[50vh] md:h-full"
            style={{ backgroundImage: "url('/images/auth/authbg2.jpg')" }}
        >
            {/* Optional overlay */}
            {/* <div className="absolute inset-0 bg-black opacity-60"></div> */}

            {/* Centered logo */}
            <div className="absolute inset-0 flex items-start justify-center z-10">
                <img src="/images/auth/logo.png" alt="Icon" className="w-2/4" />
            </div>
        </div>

    );
};

export default AuthBackground;
